import { Directive, ElementRef } from '@angular/core';

@Directive({
    selector: '[custom-input]',
})
export class InputDirective {
    public constructor(public el?: ElementRef) {}
}
